import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Product} from '../../dto/product';
import {Company} from '../../dto/company';
import {ProductService} from '../../home/services/product.service';
import {OrderService} from '../services/order.service';

@Component({
  selector: 'app-verification-complete',
  templateUrl: './verification-complete.component.html',
  styleUrls: ['./verification-complete.component.css']
})
export class VerificationCompleteComponent implements OnInit {
  type: string;
  productId: number|null;
  companyId: number|null;
  firstname: string;
  lang: string;
  product: Product|null;
  company: Company|null;
  customerCity: string;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
  ) {

  }

  ngOnInit() {
    this.type = this.route.snapshot.queryParamMap.get('type');
    const p = parseInt(this.route.snapshot.queryParamMap.get('pid'));
    if ( !isNaN(p)) {
this.productId = p;
}

    this.firstname = this.route.snapshot.queryParamMap.get('firstname');
    this.customerCity = this.route.snapshot.queryParamMap.get('customercity');
    this.lang = this.route.snapshot.queryParamMap.get('lang');

    if ( this.productId) {
      this.orderService.getProductById(this.productId).subscribe(p => {
        this.product = p;
        this.company = p.company;

      });
    }


  }

}
